import { render, staticRenderFns } from "./BrandAction.vue?vue&type=template&id=5bc7f27c"
import script from "./BrandAction.vue?vue&type=script&lang=js"
export * from "./BrandAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports